import { render, staticRenderFns } from "./CollapseAccordion.vue?vue&type=template&id=4d73498b&"
import script from "./CollapseAccordion.vue?vue&type=script&lang=js&"
export * from "./CollapseAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports